import { RootState } from '../../../../redux/store';

export const selectAgentsById = (state: RootState) => state.agents.byId;
